var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sortedDataProperties),function(property){return _c('data-prop',{key:property.name.value,attrs:{"dataProperty":property,"highlights":_vm.highlights}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }